module.exports = __webpack_public_path__ + "img/content5_212_15.959960be.png";